<template>
  <section class="moments-tiktok" :class="{ 'is-discovery-grid': activeTab === 'discoverygrid', 'is-foryou': activeTab === 'foryou', 'is-discover': activeTab === 'discover' }">
    <div class="moments-content" :class="{ 'is-discovery-grid': activeTab === 'discoverygrid', 'is-foryou': activeTab === 'foryou', 'is-discover': activeTab === 'discover' }">
      <!-- Floating Promo Banner -->
      <div 
        v-if="activeCampaign && activeTab !== 'discoverygrid'"
        class="floating-promo"
        :class="{ 'is-expanded': promoExpanded }"
        @click="goToCampaign"
        @touchstart="onPromoTouchStart"
        @touchmove="onPromoTouchMove"
        @touchend="onPromoTouchEnd"
      >
        <div class="promo-badge">
          <span class="promo-icon">✨</span>
        </div>
        <div class="promo-content">
          <span class="promo-text">{{ activeCampaign.campaignHeader || $t('Special Offer') }}</span>
          <span class="promo-cta">{{ $t('See All') }} →</span>
        </div>
      </div>

      <b-overlay
        :show="loading && data.length === 0 && activeTab === 'discover'"
        no-center
        variant="transparent"
        rounded="sm"
      >
        <template #overlay>
          <loading-spinner />
        </template>

        <!-- Floating Animated Gradient Hearts Backdrop & Manşet-Width Ambient Top Shadow -->
        <div v-if="activeTab !== 'discover'" class="moments-floating-hearts-container" aria-hidden="true">
          <!-- Ambient Top Shadow (Manşet genişliğinde ve Sana Özel yazısına kadar inen) -->
          <div class="top-menu-ambient-shadow"></div>

          <!-- Left Big Floating Gradient Heart -->
          <div class="header-floating-heart heart-left-big">
            <svg viewBox="-12 -12 124 124" class="svg-heart-gradient">
              <defs>
                <linearGradient id="headerHeartGradLeft" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#ff2ea6" stop-opacity="0.9" />
                  <stop offset="55%" stop-color="#ea03b2" stop-opacity="0.6" />
                  <stop offset="100%" stop-color="#7928ca" stop-opacity="0.2" />
                </linearGradient>
                <filter id="headerHeartGlowLeft" x="-30%" y="-30%" width="160%" height="160%">
                  <feGaussianBlur stdDeviation="3.5" result="blur" />
                  <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
              </defs>
              <path
                d="M50,88 C20,62 5,42 5,26 C5,12 16,3 29,3 C38,3 46,8 50,16 C54,8 62,3 71,3 C84,3 95,12 95,26 C95,42 80,62 50,88 Z"
                fill="none"
                stroke="url(#headerHeartGradLeft)"
                stroke-width="6.5"
                filter="url(#headerHeartGlowLeft)"
              />
            </svg>
          </div>

          <!-- Left Small Floating Heart -->
          <div class="header-floating-heart heart-left-small">
            <svg viewBox="-6 -6 36 36" class="svg-heart-small">
              <defs>
                <linearGradient id="headerHeartSmallGradLeft" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#ff3eab" />
                  <stop offset="100%" stop-color="#ea03b2" />
                </linearGradient>
              </defs>
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                fill="url(#headerHeartSmallGradLeft)"
              />
            </svg>
          </div>

          <!-- Right Small Floating Heart -->
          <div class="header-floating-heart heart-right-small">
            <svg viewBox="-6 -6 36 36" class="svg-heart-small">
              <defs>
                <linearGradient id="headerHeartSmallGradRight" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#ff3eab" />
                  <stop offset="100%" stop-color="#ea03b2" />
                </linearGradient>
              </defs>
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                fill="url(#headerHeartSmallGradRight)"
              />
            </svg>
          </div>

          <!-- Right Big Floating Gradient Heart -->
          <div class="header-floating-heart heart-right-big">
            <svg viewBox="-12 -12 124 124" class="svg-heart-gradient">
              <defs>
                <linearGradient id="headerHeartGradRight" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#ff2ea6" stop-opacity="0.9" />
                  <stop offset="55%" stop-color="#ea03b2" stop-opacity="0.6" />
                  <stop offset="100%" stop-color="#7928ca" stop-opacity="0.2" />
                </linearGradient>
                <filter id="headerHeartGlowRight" x="-30%" y="-30%" width="160%" height="160%">
                  <feGaussianBlur stdDeviation="3.5" result="blur" />
                  <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
              </defs>
              <path
                d="M50,88 C20,62 5,42 5,26 C5,12 16,3 29,3 C38,3 46,8 50,16 C54,8 62,3 71,3 C84,3 95,12 95,26 C95,42 80,62 50,88 Z"
                fill="none"
                stroke="url(#headerHeartGradRight)"
                stroke-width="6.5"
                filter="url(#headerHeartGlowRight)"
              />
            </svg>
          </div>
        </div>

        <!-- For You Swipe Cards -->
        <for-you-swipe-cards
          v-if="activeTab === 'foryou'"
          @switch-tab="switchTab"
          @open-new-post="newPostModal = true"
        />

        <!-- Discovery Grid -->
        <discovery-grid v-if="activeTab === 'discoverygrid'" @switch-tab="switchTab" />

        <!-- Swiper Container (Discover Tab) -->
        <div
          v-else-if="activeTab === 'discover'"
          ref="swiperContainer"
          class="swiper-container"
          tabindex="0"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
          @wheel="onWheel"
          @keydown.down.prevent="goToIndex(currentIndex + 1)"
          @keydown.up.prevent="goToIndex(currentIndex - 1)"
        >
          <div
            v-if="data.length > 0"
            class="swiper-wrapper"
            :style="swiperStyle"
          >
            <div
              v-for="(post, index) in data"
              :key="post.id"
              class="swiper-slide"
              :class="{ active: currentIndex === index }"
              :style="slideStyle"
            >
              <!-- Media Background -->
              <div class="media-container" @dblclick="onDoubleTapMedia(post)">
                <!-- Big Heart Pop Animation on Double Tap -->
                <transition name="heart-pop">
                  <div v-if="post.showHeartAnim" class="heart-pop-anim">
                    <svg width="90" height="90" viewBox="0 0 24 24" fill="#ff2d55">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                    </svg>
                  </div>
                </transition>

                <!-- Shimmer skeleton -->
                <div v-if="!post.mediaLoaded" class="media-skeleton">
                  <div class="shimmer"></div>
                </div>

                <!-- Video Media -->
                <video
                  v-if="isPostVideo(post)"
                  v-show="post.mediaLoaded"
                  ref="videoRefs"
                  :src="post.media_url"
                  class="media-content is-video"
                  loop
                  playsinline
                  :muted="isMuted"
                  @loadeddata="onMediaLoad(post)"
                  @error="onMediaLoad(post)"
                  @click="togglePlayPause(index)"
                />

                <!-- Image Media -->
                <img
                  v-else
                  v-show="post.mediaLoaded"
                  :src="post.media_url || post.profile_photo_url"
                  class="media-content"
                  alt=""
                  @load="onMediaLoad(post)"
                  @error="onMediaLoad(post)"
                >
              </div>

              <!-- Right Actions (TikTok / Reels Style) -->
              <div class="right-actions">
                <!-- Create Post Action (+) -->
                <div
                  class="action-item create-action"
                  @click.stop="newPostModal = true"
                  :title="$t('Create Post') || 'Yeni Gönderi'"
                >
                  <div class="outer-ring">
                    <div class="inner-ring">
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </div>
                  </div>
                </div>

                <!-- Profile Avatar with Follow Badge -->
                <div
                  class="action-item profile-action"
                  @click.stop="userId !== post.uuid ? toggleFollow(post) : goToProfile(post.uuid)"
                >
                  <div class="avatar-wrapper" :class="{ followed: post.is_followed }">
                    <b-avatar
                      size="48"
                      :src="post.profile_photo_url"
                      variant="light-primary"
                    />
                  </div>
                  <div
                    v-if="userId !== post.uuid"
                    class="follow-badge"
                    :class="{ followed: post.is_followed }"
                  >
                    <span v-if="post.is_followed">✓</span>
                    <font-awesome-icon
                      v-else
                      :icon="['fas', 'plus']"
                    />
                  </div>
                </div>

                <!-- Like Heart -->
                <div
                  class="action-item heart-action"
                  @click.stop="toggleLike(post)"
                >
                  <font-awesome-icon
                    :icon="post.is_liked ? ['fas', 'heart'] : ['far', 'heart']"
                    :class="{ liked: post.is_liked }"
                  />
                  <span v-if="post.like_count > 0" class="action-count">{{ formatCount(post.like_count) }}</span>
                </div>

                <!-- Sound / Mute Toggle (Only for videos) -->
                <div
                  v-if="isPostVideo(post)"
                  class="action-item sound-action"
                  @click.stop="toggleMute"
                  :title="isMuted ? ($t('Unmute') || 'Sesi Aç') : ($t('Mute') || 'Sesi Kapat')"
                >
                  <svg v-if="isMuted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                  </svg>
                </div>

                <!-- 3 Dots Options -->
                <div
                  class="action-item more-action"
                  @click.stop="showActionsModal(post)"
                  :title="$t('Options') || 'Seçenekler'"
                >
                  <div class="more-icon-wrapper">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="5" r="2.2"></circle>
                      <circle cx="12" cy="12" r="2.2"></circle>
                      <circle cx="12" cy="19" r="2.2"></circle>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Bottom Info Section -->
              <div class="bottom-info">
                <div class="user-info">
                  <b-avatar
                    size="44"
                    :src="post.profile_photo_url"
                    variant="light-primary"
                    class="user-avatar"
                    @click.native.stop="goToProfile(post.uuid)"
                  />
                  <div class="user-details">
                    <div class="user-name-row" @click.stop="goToProfile(post.uuid)">
                      <span class="username">{{ post.user_name }}</span>
                      <span v-if="post.age" class="user-age">, {{ post.age }}</span>
                      <span
                        v-if="post.is_verified"
                        class="verified-badge"
                      >
                        <font-awesome-icon :icon="['fas', 'certificate']" />
                      </span>
                    </div>

                    <!-- AI / Real Prominent Badge -->
                    <div class="badge-wrapper">
                      <span
                        class="content-type-badge"
                        :class="post.is_ai ? 'ai' : 'real'"
                      >
                        <span v-if="post.is_ai" class="badge-icon">✦</span>
                        <span v-else class="badge-dot"></span>
                        <span class="badge-text">{{ post.is_ai ? 'AI' : 'REAL' }}</span>
                      </span>
                    </div>

                    <!-- Post Caption -->
                    <div v-if="post.content" class="content-text">
                      {{ post.content }}
                    </div>
                  </div>
                </div>

                <!-- Mesaj kutusu yerine iki ikonlu buton: arama (backend'den gelen camera_on/voice_on'a göre
                     sesli ya da görüntülü, Keşfet kartlarıyla aynı kural) ve mesaj (sohbeti açar) -->
                <div
                  v-if="userId !== post.uuid"
                  class="moment-actions-bar"
                  @click.stop
                >
                  <button
                    v-if="getCallMode(post) === 'voice'"
                    type="button"
                    class="moment-action-btn moment-action-call"
                    @click.stop="call(post)"
                  >
                    <feather-icon icon="PhoneIcon" size="18" />
                    <span>{{ $t('Voice Call') }}</span>
                  </button>
                  <button
                    v-else-if="getCallMode(post) === 'video'"
                    type="button"
                    class="moment-action-btn moment-action-call"
                    @click.stop="videoCall(post)"
                  >
                    <feather-icon icon="VideoIcon" size="18" />
                    <span>{{ $t('Video Call') }}</span>
                  </button>
                  <button
                    type="button"
                    class="moment-action-btn moment-action-message"
                    @click.stop="chat(post)"
                  >
                    <feather-icon icon="MessageCircleIcon" size="18" />
                    <span>{{ $t('Send Message') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div
            v-else-if="!loading"
            class="empty-state"
          >
            <h3>{{ $t('No moments title') }}</h3>
            <b-img
              fluid
              :src="imageDiscoverNoUser"
            />
          </div>
        </div>
    </b-overlay>
    </div>

    <!-- Actions Modal -->
    <b-modal
      v-model="showActionsModalVisible"
      modal-class="actions-modal"
      centered
      hide-header
      hide-footer
      content-class="actions-modal-content"
    >
      <div class="actions-list">
        <div
          class="action-item"
          @click="viewProfile"
        >
          <span class="action-icon">👤</span> {{ $t('View profile') }}
        </div>
        <div
          v-if="selectedPostForActions && userId !== selectedPostForActions.uuid"
          class="action-item"
          @click="openChatFromAction"
        >
          <span class="action-icon">💬</span> {{ $t('Send Message') || 'Mesaj Gönder' }}
        </div>
        <div
          class="action-item"
          @click="copyPostLink"
        >
          <span class="action-icon">🔗</span> {{ $t('Copy Link') || 'Bağlantıyı Kopyala' }}
        </div>
        <div
          v-if="selectedPostForActions && userId !== selectedPostForActions.uuid"
          class="action-item text-danger"
          @click="blockSelectedUser"
        >
          <span class="action-icon">🚫</span> {{ $t('Block') }}
        </div>
        <div
          v-if="selectedPostForActions && userId !== selectedPostForActions.uuid"
          class="action-item text-warning"
          @click="reportSelectedUser"
        >
          <span class="action-icon">⚠️</span> {{ $t('Report') }}
        </div>
        <div
          v-if="selectedPostForActions && userId === selectedPostForActions.uuid"
          class="action-item text-danger"
          @click="removeSelectedPost"
        >
          <span class="action-icon">🗑️</span> {{ $t('Remove') }}
        </div>
        <div
          class="action-item cancel"
          @click="showActionsModalVisible = false"
        >
          {{ $t('Cancel') }}
        </div>
      </div>
    </b-modal>

    <!-- New Post Modal -->
    <b-modal
      v-model="newPostModal"
      modal-class="new-post-modal"
      size="lg"
      centered
      hide-header
      hide-footer
    >
      <div class="np-head">
        <div class="np-title">
          <span class="np-icon">
            <feather-icon
              icon="PlusIcon"
              size="20"
            />
          </span>
          <div>
            <h3>{{ $t('Share a moment') }}</h3>
            <p>{{ $t('Upload photo or video') }}</p>
          </div>
        </div>
        <button
          type="button"
          class="np-close"
          :aria-label="$t('Close')"
          @click="newPostModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="20"
          />
        </button>
      </div>

      <!--
        Input her zaman DOM'da kalmalı. Safari/WebKit'te seçilen File, input
        elemanına bağlı geçici bir dosyayı işaret ediyor; input v-if ile yok
        edilince o dosya serbest bırakılıyor ve publish anında FormData boş
        part gönderiyor.
      -->
      <input
        ref="file"
        type="file"
        accept="image/*,video/*"
        style="display: none;"
        @change="onFileChange"
      >
      <div
        v-if="!file"
        class="new-post-modal-upload"
        role="button"
        tabindex="0"
        @click="$refs.file.click()"
        @keyup.enter="$refs.file.click()"
      >
        <div class="np-upload-icons">
          <span class="np-upload-icon photo">
            <feather-icon
              icon="CameraIcon"
              size="28"
            />
          </span>
          <span class="np-upload-icon video">
            <feather-icon
              icon="VideoIcon"
              size="28"
            />
          </span>
        </div>
        <div class="np-upload-text">
          {{ $t('Upload photo or video') }}
        </div>
        <span class="np-upload-btn">
          <feather-icon
            icon="UploadIcon"
            size="16"
          />
          {{ $t('Choose file') }}
        </span>
      </div>
      <div
        v-else
        class="new-post-modal-preview"
      >
        <div
          id="new-post-modal-viewer"
          v-viewer
        >
          <img
            v-if="fileType === 'image'"
            :src="file"
            alt="image"
          >
          <b-embed
            v-if="fileType === 'video'"
            :src="file"
            type="video"
            controls
          />
        </div>
        <button
          type="button"
          class="np-remove"
          :disabled="loading"
          :title="$t('Delete')"
          @click="removeFile"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <div class="np-text">
        <b-form-textarea
          id="content"
          v-model="content"
          :disabled="loading"
          :placeholder="$t('Enter your text here') + '. (' + $t('Max 100 characters') + '.)'"
          class="np-textarea"
          rows="3"
          max-rows="6"
        />
        <span
          class="np-counter"
          :class="{ over: (content || '').length > 100 }"
        >{{ (content || '').length }}/100</span>
      </div>

      <div
        class="form-accepted"
        :class="{ checked: formAccepted }"
      >
        <b-form-checkbox
          v-model="formAccepted"
          name="check-button"
          class="np-check"
        />
        <span>{{ $t('New post checkbox text') }}</span>
      </div>

      <button
        type="button"
        class="np-publish"
        :disabled="!file || !formAccepted || loading"
        @click="publish"
      >
        <b-spinner
          v-if="loading"
          small
        />
        <feather-icon
          v-else
          icon="SendIcon"
          size="17"
        />
        {{ loading ? $t('Publishing') + '...' : $t('Publish') }}
      </button>
    </b-modal>

    <!-- Report Modal -->
    <b-modal
      v-if="selectedPostForActions"
      v-model="modalReportUser"
      :title="$t('Report {name}', {name: selectedPostForActions.user_name})"
      centered
      hide-header-close
      hide-footer
    >
      <validation-observer
        v-if="reportReasonTypes.length"
        ref="reportForm"
      >
        <b-form
          class="mt-2"
          @submit.prevent
        >
          <b-form-group
            label-for="reason"
            :label="$t('Report reason')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Report reason')"
              vid="reason"
              rules="required"
            >
              <v-select
                v-model="report.reason"
                :clearable="false"
                :disabled="loading"
                label="title"
                :options="reportReasonTypes"
                :reduce="option => option.value"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            v-if="report.reason === 'Other'"
            label-for="reportMessage"
            :label="$t('Your message')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Your message')"
              vid="description"
              rules="required"
            >
              <b-form-textarea
                id="description"
                v-model="report.description"
                :disabled="loading"
                :placeholder="$t('Your message')"
                rows="3"
                max-rows="6"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div class="d-flex justify-content-end">
            <b-button
              variant="primary"
              class="mt-2 px-4 mb-6"
              :disabled="loading"
              @click="reportUser"
            >
              <b-spinner
                v-if="loading"
                small
              />
              {{ $t('Report') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>

<!-- Hediye satışı kaldırıldı — hediye seçme modalı devre dışı
    <b-modal
      v-if="gifts.length > 0"
      v-model="chooseGiftModal"
      body-class="choose-gift-modal-body"
      scrollable
      hide-footer
      size="lg"
    >
      <div class="choose-gift-modal">
        <div
          v-for="gift in gifts"
          :key="gift.productId"
          class="gift"
        >
          <b-img
            width="48"
            :alt="gift.label"
            :src="getImgGift(gift.image)"
            class="gift-image"
            @click="sendGift(gift)"
          />
          <p
            v-if="userGender === 'male'"
            class="gift-price"
          >
            <b-img
              :src="iconDiamonds1"
              width="16"
              height="16"
              style="margin-top: -2px"
            />
            {{ numberFormat(gift.credits) }}
          </p>
        </div>
      </div>
    </b-modal>
    -->
  </section>
</template>


<script>
import 'viewerjs/dist/viewer.css'
import {
  BAvatar,
  BButton,
  BEmbed,
  BFormCheckbox,
  BFormTextarea,
  BImg,
  BModal,
  BOverlay,
  BSpinner,
  BFormGroup,
  BForm,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import {
  gtmTrackNewEvent, numberFormat, showNotify, snapshotFile, throwDefaultError,
} from '@/helpers/helpers'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import ForYouSwipeCards from '@/components/ForYouSwipeCards.vue'
import DiscoveryGrid from '@/components/DiscoveryGrid.vue'
import userCallActions from '@/mixins/userCallActions'

const iconDiamonds1 = require('@/assets/images/icons/diamonds-1.svg')
const imageDiscoverNoUser = require('@/assets/images/pages/discover-no-user.png')
const imagePhoto = require('@/assets/images/icons/camera.png')
const imageVideo = require('@/assets/images/icons/video.png')

export default {
  name: 'Moments',
  mixins: [userCallActions],
  components: {
    BAvatar,
    BButton,
    BEmbed,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormTextarea,
    BImg,
    BModal,
    BOverlay,
    BSpinner,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    ForYouSwipeCards,
    DiscoveryGrid,
  },
  data() {
    return {
      activeTab: 'discoverygrid',
      discoveryGridEnabled: true,
      chooseGiftModal: false,
      content: '',
      currentIndex: 0,
      data: [],
      file: null,
      fileRaw: null,
      fileMaxSize: 1024 * 1024 * 100,
      fileType: null,
      formAccepted: false,
      gifts: [],
      iconDiamonds1,
      imageDiscoverNoUser,
      imagePhoto,
      imageVideo,
      isMuted: true,
      isTransitioning: false,
      limit: 10,
      loading: false,
      modalReportUser: false,
      newPostModal: false,
      offset: 0,
      postsAllLoaded: false,
      report: {
        reason: '',
        description: '',
      },
      selectedPostForActions: null,
      selectedUser: null,
      showActionsModalVisible: false,
      messageText: '',
      postMessageInputs: {},
      // Arama istatistiğinde kaynak (userCallActions mixin'i kullanır)
      callSource: 'moments',
      touchStartY: 0,
      touchEndY: 0,
      translateY: 0,
      slideHeight: window.innerHeight || 800,
      wheelAccumulator: 0,
      wheelLocked: false,
      wheelTimeout: null,
      // Promo
      promoExpanded: false,
      promoExpandTimer: null,
      promoCollapseTimer: null,
      promoTouchStartX: 0,
      // ResizeObserver
      resizeObserver: null,
    }
  },
  computed: {
    activeCampaign() {
      const campaigns = this.$store.getters['app/campaigns'] || []
      return campaigns.find(c => 
        c.campaignHeader && 
        c.webProduct && 
        Array.isArray(c.displayAreas) && 
        c.displayAreas.includes('banner')
      ) || null
    },
    reportReasonTypes() {
      return this.$store.getters['app/reportReasonTypes']
    },
    socket() {
      return this.$store.getters['socket/chatConnection']
    },
    socketConnected() {
      return this.$store.getters['socket/connected']
    },
    swiperStyle() {
      return {
        transform: `translateY(${this.translateY}px)`,
        transition: this.isTransitioning ? 'transform 0.3s ease-out' : 'none',
      }
    },
    slideStyle() {
      // slideHeight 0 veya undefined ise 100vh kullan (fallback)
      const height = this.slideHeight > 0 ? this.slideHeight : window.innerHeight
      return {
        height: `${height}px`,
        minHeight: `${height}px`,
      }
    },
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    userId() {
      return this.$store.getters['auth/userId']
    },
  },
  watch: {
    activeCampaign: {
      immediate: true,
      handler(campaign) {
        if (campaign?.campaignId) {
          useJwt.campaignsDisplayed({ campaignId: campaign.campaignId })
        }
      }
    },
    data: {
      handler() {
        // Data değiştiğinde yüksekliği yeniden hesapla
        this.$nextTick(() => {
          this.calculateSlideHeight()
        })
      }
    },
    activeTab(newTab) {
      // Tab değiştiğinde yüksekliği yeniden hesapla
      if (newTab === 'discover') {
        if (this.data.length === 0) {
          this.getMoments()
        }
        this.$nextTick(() => {
          // Swiper container v-if ile yeniden oluşturulduğu için observer'ı yeniden bağla
          this.setupResizeObserver()
          this.calculateSlideHeight()
        })
      }
    },
    '$route.query.tab'(newTab) {
      this.activeTab = newTab || 'discoverygrid'
      if (this.activeTab === 'discover') {
        if (this.data.length === 0) {
          this.getMoments()
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.calculateSlideHeight()
          }, 50)
        })
      }
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    } else {
      this.activeTab = 'discoverygrid'
    }
    this.discoveryGridEnabled = true
    if (this.activeTab === 'discover') {
      this.getMoments()
    }
    // Hediye satışı kaldırıldı
    // this.getGifts()
    useJwt.getPostsDiscoveryOpen()
      .then(response => {
        if (response && response.data && response.data.body !== undefined) {
          this.discoveryGridEnabled = response.data.body === true
        }
      })
      .catch(() => {})
  },
  mounted() {
    document.body.classList.add('moments-active')
    // DOM'un tam render olmasını bekle - özellikle route geçişlerinde
    this.$nextTick(() => {
      // requestAnimationFrame ile browser'ın paint cycle'ını bekle
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.calculateSlideHeight()
          this.updateTranslateY()
          this.setupResizeObserver()
        })
      })
    })
    this.startPromoExpandTimer()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onWindowScroll, { passive: true })
  },
  activated() {
    document.body.classList.add('moments-active')
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    } else {
      this.activeTab = 'discoverygrid'
    }
    // keep-alive'dan geri dönüldüğünde yüksekliği yeniden hesapla
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.calculateSlideHeight()
      })
    })
  },
  deactivated() {
    document.body.classList.remove('moments-active')
  },
  beforeDestroy() {
    document.body.classList.remove('moments-active')
    this.clearPromoTimers()
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onWindowScroll)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    blockSelectedUser() {
      if (this.selectedPostForActions) {
        this.blockUser(this.selectedPostForActions.uuid)
        this.showActionsModalVisible = false
      }
    },
    blockUser(id) {
      this.loading = true
      useJwt.blockUser(id)
        .then(() => {
          showNotify(this.$toast, this.$t('User blocking successful'), 'success')
          gtmTrackNewEvent('blockuser', {
            category: 'Profile',
            action: 'BlockUser',
            label: id,
          })
          this.getMoments()
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    formatCount(count) {
      if (count >= 1000000) {
        return `${(count / 1000000).toFixed(1)}M`
      }
      if (count >= 1000) {
        return `${(count / 1000).toFixed(1)}K`
      }
      return count.toString()
    },
    getGifts() {
      useJwt.getGifts()
        .then(response => {
          this.gifts = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
    },
    getImgGift(name) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/images/gifts/${name}`)
    },
    getMoments(clear = true) {
      if (clear) {
        this.data = []
        this.offset = 0
        this.postsAllLoaded = false
        this.currentIndex = 0
      }
      this.loading = true
      useJwt.getPosts(this.offset, this.limit)
        .then(response => {
          const _data = (response.data.body || []).map(post => ({
            ...post,
            mediaLoaded: true,
            showHeartAnim: false,
          }))
          if (clear) {
            this.data = _data
          } else {
            this.data.push(..._data)
          }
          this.offset += this.limit
          if (_data.length < this.limit) {
            this.postsAllLoaded = true
          }
          this.$nextTick(() => {
            this.calculateSlideHeight()
            this.updateTranslateY()
            this.playCurrentVideo()
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    goToIndex(index) {
      if (index < 0 || index >= this.data.length || this.isTransitioning) return
      this.pauseAllVideos()
      this.isTransitioning = true
      this.currentIndex = index
      this.updateTranslateY()
      setTimeout(() => {
        this.isTransitioning = false
        this.playCurrentVideo()
      }, 300)
      if (index >= this.data.length - 3 && !this.postsAllLoaded && !this.loading) {
        this.getMoments(false)
      }
    },
    goToProfile(uuid) {
      this.$router.push({
        name: 'users.show',
        params: { id: uuid },
      })
    },
    numberFormat(value) {
      return numberFormat(value)
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      const _file = files[0]
      if (_file.size > this.fileMaxSize) {
        showNotify(this.$toast, this.$t('File size should be maximum {size}', { size: '100 MB' }))
        this.removeFile()
        return
      }
      if (!_file.type.includes('image/') && !_file.type.includes('video/')) {
        showNotify(this.$toast, this.$t('You can only upload photos or videos'))
        this.removeFile()
        return
      }

      this.fileRaw = await snapshotFile(_file)

      this.fileType = _file.type.includes('image/') ? 'image' : 'video'
      if (this.file) URL.revokeObjectURL(this.file)
      this.file = URL.createObjectURL(this.fileRaw)
    },
    removeFile() {
      if (this.file) URL.revokeObjectURL(this.file)
      this.file = null
      this.fileRaw = null
      this.fileType = null
      // Input artık DOM'da kalıcı olduğu için value'yu elle sıfırlamazsak
      // aynı dosya ikinci kez seçildiğinde change olayı hiç tetiklenmez.
      if (this.$refs.file) this.$refs.file.value = ''
    },
    onTouchEnd() {
      if (this.activeTab !== 'discover') return
      const diff = this.touchStartY - this.touchEndY
      const threshold = 45
      if (Math.abs(diff) > threshold) {
        if (diff > 0 && this.currentIndex < this.data.length - 1) {
          this.goToIndex(this.currentIndex + 1)
        } else if (diff < 0 && this.currentIndex > 0) {
          this.goToIndex(this.currentIndex - 1)
        } else {
          this.updateTranslateY()
        }
      } else {
        this.updateTranslateY()
      }
    },
    onTouchMove(e) {
      if (this.activeTab !== 'discover') return
      if (!e.touches || !e.touches[0]) return
      this.touchEndY = e.touches[0].clientY
      const diff = this.touchStartY - this.touchEndY
      // Resistance at edges
      if ((this.currentIndex === 0 && diff < 0) || (this.currentIndex === this.data.length - 1 && diff > 0)) {
        this.translateY = -(this.currentIndex * this.slideHeight) - (diff * 0.3)
      } else {
        this.translateY = -(this.currentIndex * this.slideHeight) - diff
      }
    },
    onTouchStart(e) {
      if (this.activeTab !== 'discover') return
      if (!e.touches || !e.touches[0]) return
      this.touchStartY = e.touches[0].clientY
      this.touchEndY = e.touches[0].clientY
    },
    onWheel(e) {
      if (this.activeTab !== 'discover') return
      e.preventDefault()
      
      // Scroll kilidi aktifse hiçbir şey yapma
      if (this.wheelLocked) {
        this.wheelAccumulator = 0
        return
      }

      this.wheelAccumulator += e.deltaY

      const threshold = 60
      
      if (Math.abs(this.wheelAccumulator) >= threshold) {
        // Önce kilitle, sonra hareket et
        this.wheelLocked = true
        this.wheelAccumulator = 0
        
        const direction = e.deltaY > 0 ? 1 : -1
        this.goToIndex(this.currentIndex + direction)
        
        // 500ms sonra kilidi aç
        setTimeout(() => {
          this.wheelLocked = false
          this.wheelAccumulator = 0
        }, 500)
      }
    },
    openChat(post) {
      this.$router.push({
        name: 'chat',
        params: { id: post.uuid },
      })
    },
    openGiftModal() {
      if (this.selectedPostForActions) {
        this.selectedUser = {
          userName: this.selectedPostForActions.user_name,
          uuid: this.selectedPostForActions.uuid,
        }
        this.showActionsModalVisible = false
        this.chooseGiftModal = true
      }
    },
    sendMessage(post) {
      const text = (this.postMessageInputs[post.id] || this.messageText || '').trim()
      if (!text) return
      
      if (!this.socket || !this.socketConnected) {
        showNotify(this.$toast, this.$t('Connecting to the system. Please wait.'), 'warning')
        return
      }

      const payload = {
        from: this.userId,
        to: post.uuid,
        content: text,
        type: 'CHAT_MSG',
        source: 'moment',
        source_id: post.id,
      }

      this.socket.emit('send', payload)
      showNotify(this.$toast, this.$t('Message sent successfully'), 'success')
      this.$set(this.postMessageInputs, post.id, '')
      this.messageText = ''
    },
    pauseAllVideos() {
      const videos = this.$el.querySelectorAll('video')
      videos.forEach(video => {
        video.pause()
      })
    },
    playCurrentVideo() {
      this.$nextTick(() => {
        const slides = this.$el.querySelectorAll('.swiper-slide')
        slides.forEach((slide, idx) => {
          const video = slide.querySelector('video')
          if (video) {
            if (idx === this.currentIndex) {
              video.play().catch(() => {})
            } else {
              video.pause()
            }
          }
        })
      })
    },
    publish() {
      // fileRaw yoksa append('file', null) string olarak "null" gönderir,
      // backend de dosyasız bir istek almış olur.
      if (!this.fileRaw) {
        showNotify(this.$toast, this.$t('You can only upload photos or videos'))
        return
      }
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('file', this.fileRaw, this.fileRaw.name || 'upload')
        formData.append('content', this.content)
        useJwt.newPost(formData)
          .then(() => {
            const _message = `${this.$t('Post created successfully')}. ${this.$t('The post will be published after approval')}.`
            showNotify(this.$toast, _message, 'success')
            this.newPostModal = false
            this.removeFile()
            this.content = ''
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
          })
      } catch (e) {
        this.loading = false
      }
    },
    removeSelectedPost() {
      if (this.selectedPostForActions) {
        this.loading = true
        useJwt.deletePost(this.selectedPostForActions.id)
          .then(() => {
            this.getMoments()
            showNotify(this.$toast, this.$t('Deleted successfully'), 'success')
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
            this.showActionsModalVisible = false
          })
      }
    },
    reportSelectedUser() {
      if (this.selectedPostForActions) {
        this.modalReportUser = true
        this.showActionsModalVisible = false
      }
    },
    reportUser() {
      this.loading = true
      const data = {
        related_id: this.selectedPostForActions.id,
        reason: this.report.reason === 'Other' ? this.report.description : this.report.reason,
        report_source: 'moment',
        reported_uuid: this.selectedPostForActions.uuid,
      }
      useJwt.reportUser2(data)
        .then(() => {
          showNotify(this.$toast, this.$t('Reporting user successful'), 'success')
          this.modalReportUser = false
          gtmTrackNewEvent('reportuser', {
            category: 'Profil',
            action: 'ReportUser',
            label: this.selectedPostForActions.uuid,
          })
          this.report = { reason: '', description: '' }
          this.selectedPostForActions = null
          this.getMoments()
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    sendGift(gift) {
      this.loading = true
      const data = {
        productId: gift.productId,
        targetUserUuid: this.selectedUser.uuid,
      }
      useJwt.sendGift(data)
        .then(() => {
          showNotify(this.$toast, this.$t('Gift sending successful'), 'success')
          this.chooseGiftModal = false
          gtmTrackNewEvent('giftsent', {
            category: 'Profil',
            action: 'GiftSent',
            label: this.selectedUser.uuid,
          })
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showActionsModal(post) {
      this.selectedPostForActions = post
      this.showActionsModalVisible = true
    },
    openChatFromAction() {
      if (this.selectedPostForActions) {
        const targetUuid = this.selectedPostForActions.uuid
        this.showActionsModalVisible = false
        this.$router.push({
          name: 'chat',
          params: { userId: targetUuid },
        })
      }
    },
    copyPostLink() {
      if (this.selectedPostForActions) {
        const shareUrl = `${window.location.origin}/moments?tab=discover&id=${this.selectedPostForActions.id}`
        if (navigator.clipboard) {
          navigator.clipboard.writeText(shareUrl)
        }
        showNotify(this.$toast, this.$t('Link copied to clipboard') || 'Bağlantı kopyalandı', 'success')
        this.showActionsModalVisible = false
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.goToIndex(this.currentIndex - 1)
      }
    },
    nextSlide() {
      if (this.currentIndex < this.data.length - 1) {
        this.goToIndex(this.currentIndex + 1)
      }
    },
    isPostVideo(post) {
      if (!post) return false
      if (post.media_type === 'video') return true
      if (typeof post.media_type === 'string' && post.media_type.toLowerCase().includes('video')) return true
      if (post.media_url && typeof post.media_url === 'string' && /\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(post.media_url)) return true
      return false
    },
    onMediaLoad(post) {
      this.$set(post, 'mediaLoaded', true)
    },
    onWindowScroll() {
      if (this.activeTab !== 'discover') return
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight
      if (scrollY + windowHeight >= docHeight - 800 && !this.loading && !this.postsAllLoaded) {
        this.getMoments(false)
      }
    },
    onDoubleTapMedia(post) {
      this.$set(post, 'showHeartAnim', true)
      setTimeout(() => {
        this.$set(post, 'showHeartAnim', false)
      }, 900)
      if (!post.is_liked) {
        this.toggleLike(post)
      }
    },
    toggleFeedVideo(index) {
      const videoRef = this.$refs[`feedVideo-${index}`]
      const video = Array.isArray(videoRef) ? videoRef[0] : videoRef
      if (video) {
        if (video.paused) {
          video.play().catch(() => {})
        } else {
          video.pause()
        }
      }
    },
    switchTab(tab) {
      this.activeTab = tab
      if (tab === 'discover' && this.data.length === 0) {
        this.getMoments()
      }
      const targetQuery = tab === 'discoverygrid' ? {} : { tab }
      const currentTab = this.$route.query.tab
      const expectedTab = tab === 'discoverygrid' ? undefined : tab
      if (currentTab !== expectedTab) {
        this.$router.replace({
          name: 'moments',
          query: targetQuery,
        }).catch(() => {})
      }
    },
    toggleFollow(post) {
      this.loading = true
      if (!post.is_followed) {
        useJwt.addFavoriteUser(post.uuid)
          .then(() => {
            showNotify(this.$toast, this.$t('Liking successful'), 'success')
            // eslint-disable-next-line no-param-reassign
            post.is_followed = true
            gtmTrackNewEvent('addfavorite', {
              category: 'Profil',
              action: 'AddFavorite',
              label: post.uuid,
            })
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
      } else {
        useJwt.removeFavoriteUser(post.uuid)
          .then(() => {
            showNotify(this.$toast, this.$t('Unliking successful'), 'success')
            // eslint-disable-next-line no-param-reassign
            post.is_followed = false
            gtmTrackNewEvent('removefavorite', {
              category: 'Profil',
              action: 'RemoveFavorite',
              label: post.uuid,
            })
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
      }
    },
    toggleLike(post) {
      this.loading = true
      let _request = null
      if (post.is_liked) {
        _request = useJwt.likePostDelete(post.id)
      } else {
        _request = useJwt.likePost({ post_id: post.id })
      }
      if (_request) {
        _request
          .then(response => {
            // eslint-disable-next-line no-param-reassign
            post.is_liked = !post.is_liked
            // eslint-disable-next-line no-param-reassign
            post.like_count = post.is_liked ? post.like_count + 1 : post.like_count - 1
            showNotify(this.$toast, this.$t(response.data.body), 'success')
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
      }
    },
    togglePlayPause(index) {
      if (index !== this.currentIndex) return
      const slides = this.$el.querySelectorAll('.swiper-slide')
      const video = slides[index]?.querySelector('video')
      if (video) {
        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      }
    },
    toggleMute() {
      this.isMuted = !this.isMuted
    },
    updateTranslateY() {
      this.translateY = -(this.currentIndex * this.slideHeight)
    },
    calculateSlideHeight() {
      // Gerçek görünür alanı hesapla
      this.$nextTick(() => {
        const container = this.$refs.swiperContainer
        if (container && container.clientHeight > 0) {
          this.slideHeight = container.clientHeight
        } else {
          // Fallback: visualViewport veya innerHeight
          const vh = window.visualViewport 
            ? window.visualViewport.height 
            : window.innerHeight
          if (vh > 0) {
            this.slideHeight = vh
          }
        }
        // translateY'yi güncelle
        this.translateY = -(this.currentIndex * this.slideHeight)
      })
    },
    onResize() {
      this.calculateSlideHeight()
      this.updateTranslateY()
    },
    setupResizeObserver() {
      // Container boyutu değiştiğinde otomatik güncelle
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
      const container = this.$refs.swiperContainer
      if (container && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const newHeight = entry.contentRect.height
            if (newHeight > 0 && Math.abs(newHeight - this.slideHeight) > 1) {
              this.slideHeight = newHeight
              this.translateY = -(this.currentIndex * this.slideHeight)
            }
          }
        })
        this.resizeObserver.observe(container)
      }
    },
    viewProfile() {
      if (this.selectedPostForActions) {
        this.$router.push({
          name: 'users.show',
          params: { id: this.selectedPostForActions.uuid },
        })
        this.showActionsModalVisible = false
      }
    },
    onMediaLoad(post) {
      this.$set(post, 'mediaLoaded', true)
    },
    // Promo methods
    startPromoExpandTimer() {
      this.clearPromoTimers()
      // 5 saniye sonra genişlet
      this.promoExpandTimer = setTimeout(() => {
        this.promoExpanded = true
        // 4 saniye sonra tekrar küçült
        this.promoCollapseTimer = setTimeout(() => {
          this.promoExpanded = false
          // 15 saniye sonra tekrar genişlet
          this.startPromoExpandTimer()
        }, 4000)
      }, 5000)
    },
    clearPromoTimers() {
      if (this.promoExpandTimer) {
        clearTimeout(this.promoExpandTimer)
        this.promoExpandTimer = null
      }
      if (this.promoCollapseTimer) {
        clearTimeout(this.promoCollapseTimer)
        this.promoCollapseTimer = null
      }
    },
    onPromoTouchStart(e) {
      this.promoTouchStartX = e.touches[0].clientX
    },
    onPromoTouchMove(e) {
      e.preventDefault()
    },
    onPromoTouchEnd(e) {
      const touchEndX = e.changedTouches[0].clientX
      const diff = Math.abs(touchEndX - this.promoTouchStartX)
      // Swipe algılandıysa küçült
      if (diff > 30) {
        this.promoExpanded = false
        this.clearPromoTimers()
        // 15 saniye sonra tekrar başlat
        this.promoExpandTimer = setTimeout(() => {
          this.startPromoExpandTimer()
        }, 15000)
      }
    },
    goToCampaign() {
      if (this.activeCampaign?.webProduct) {
        this.$router.push({
          name: 'buy',
          params: { 
            productId: this.activeCampaign.webProduct, 
            purchaseSource: 'moments_floating_banner' 
          },
          query: { 
            campaignId: this.activeCampaign.campaignId, 
            campaignType: this.activeCampaign.campaignType 
          }
        })
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.moments-tiktok {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 72px);
  background: transparent !important;
  overflow: visible;
  display: flex;
  justify-content: center;

  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  &.is-discovery-grid,
  &.is-foryou {
    position: relative !important;
    top: 0 !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    height: auto !important;
    min-height: calc(100vh - 80px);
    overflow: visible !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent !important;
    border: none !important;
    border-bottom: none !important;
    outline: none !important;
  }

  &.is-discover {
    position: fixed !important;
    top: 72px !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    height: calc(100vh - 72px) !important;
    min-height: 0 !important;
    overflow: hidden !important;
    display: flex !important;
    justify-content: center !important;
    /* Uygulamanın genel gradyanlı arka planı (style.scss ile aynı) */
    background-color: #11172b !important;
    background-image:
      radial-gradient(ellipse 70% 45% at 50% 0%, rgba(147, 51, 234, 0.18) 0%, transparent 70%),
      linear-gradient(0deg, rgba(234, 3, 178, 0.22) 0%, rgba(234, 3, 178, 0.12) 20%, rgba(234, 3, 178, 0.04) 45%, rgba(17, 23, 43, 0) 70%) !important;
    z-index: 10 !important;

    @media (max-width: 768px) {
      top: 64px !important;
      bottom: calc(62px + env(safe-area-inset-bottom, 0px)) !important;
      // Yükseklik top/bottom'dan hesaplansın. Önceki calc(100vh - ...) mobil tarayıcıda adres çubuğu yüksekliği
      // kadar fazla çıkıyor (top+bottom+height birlikte verilince height kazanıyor), alttaki arama/mesaj
      // butonları alt menünün (tab bar) arkasında kalıyordu.
      height: auto !important;
    }
  }
}

.moments-content {
  width: 100%;
  position: relative;
  background: transparent !important;
  border: none !important;
  border-bottom: none !important;

  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  &.is-discover {
    width: 100% !important;
    max-width: 500px !important;
    height: 100% !important;
    min-height: 100% !important;
    overflow: hidden !important;
    position: relative !important;
    background: #000 !important;

    @media (max-width: 768px) {
      max-width: 100% !important;
    }
  }

  &.is-discovery-grid,
  &.is-foryou {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    height: auto !important;
    min-height: 100%;
    background: transparent !important;
    overflow: visible !important;
    border: none !important;
    border-bottom: none !important;
  }
}

.heart-pop-enter-active {
  animation: heartPopAnim 0.75s ease forwards;
}

@keyframes heartPopAnim {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  30% {
    transform: translate(-50%, -50%) scale(1.25);
    opacity: 1;
  }
  60% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.4);
    opacity: 0;
  }
}

// Floating Promo Banner
.floating-promo {
  position: absolute;
  top: 80px;
  left: 16px;
  z-index: 100;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.95), rgba(236, 72, 153, 0.95));
  border-radius: 25px;
  padding: 8px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(168, 85, 247, 0.4);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-width: 50px;
  overflow: hidden;

  @media (max-width: 768px) {
    top: 16px;
    left: 12px;
  }

  &.is-expanded {
    max-width: 280px;
    padding: 10px 16px 10px 12px;
  }

  .promo-badge {
    width: 34px;
    height: 34px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .promo-icon {
      font-size: 18px;
    }
  }

  .promo-content {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    opacity: 0;
    white-space: nowrap;
    transition: opacity 0.3s ease;

    .promo-text {
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.2;
    }

    .promo-cta {
      color: rgba(255, 255, 255, 0.85);
      font-size: 11px;
      margin-top: 2px;
    }
  }

  &.is-expanded .promo-content {
    opacity: 1;
  }
}

.moments-floating-hearts-container {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1320px;
  height: 0;
  overflow: visible !important;
  pointer-events: none;
  z-index: 1;
}

.top-menu-ambient-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 1320px;
  height: 105px;
  margin: 0 auto;
  pointer-events: none;
  background: radial-gradient(ellipse 70% 90% at 50% 0%, rgba(234, 3, 178, 0.32) 0%, rgba(147, 51, 234, 0.16) 45%, rgba(17, 23, 43, 0) 100%);
  filter: blur(16px);
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 8%;
    right: 8%;
    height: 38px;
    background: radial-gradient(ellipse 80% 100% at 50% 0%, rgba(255, 46, 166, 0.45) 0%, rgba(234, 3, 178, 0.2) 50%, transparent 100%);
    filter: blur(10px);
  }

  @media (max-width: 768px) {
    height: 75px;
  }
}

.header-floating-heart {
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible !important;

  .svg-heart-gradient {
    width: 100%;
    height: 100%;
    overflow: visible !important;
    filter: drop-shadow(0 0 16px rgba(234, 3, 178, 0.45));
  }

  .svg-heart-small {
    width: 100%;
    height: 100%;
    overflow: visible !important;
    filter: drop-shadow(0 0 10px rgba(234, 3, 178, 0.85));
  }

  &.heart-left-big {
    left: -58px;
    top: 135px;
    width: 115px;
    height: 115px;
    transform: rotate(-14deg);
    animation: pulseHeartGlowLeft 6s ease-in-out infinite;

    @media (max-width: 1199px) {
      left: -38px;
      top: 115px;
      width: 95px;
      height: 95px;
    }

    @media (max-width: 768px) {
      left: -24px;
      top: 82px;
      width: 72px;
      height: 72px;
    }
  }

  &.heart-left-small {
    left: 20px;
    top: 98px;
    width: 24px;
    height: 24px;
    transform: rotate(12deg);
    animation: floatHeartSmallLeft 4.5s ease-in-out infinite;

    @media (max-width: 1199px) {
      left: 14px;
      top: 85px;
      width: 20px;
      height: 20px;
    }

    @media (max-width: 768px) {
      left: 8px;
      top: 60px;
      width: 16px;
      height: 16px;
    }
  }

  &.heart-right-small {
    right: 20px;
    top: 92px;
    width: 24px;
    height: 24px;
    transform: rotate(-10deg);
    animation: floatHeartSmallRight 5s ease-in-out infinite;

    @media (max-width: 1199px) {
      right: 14px;
      top: 80px;
      width: 20px;
      height: 20px;
    }

    @media (max-width: 768px) {
      right: 8px;
      top: 56px;
      width: 16px;
      height: 16px;
    }
  }

  &.heart-right-big {
    right: -58px;
    top: 130px;
    width: 120px;
    height: 120px;
    transform: rotate(16deg);
    animation: pulseHeartGlowRight 7s ease-in-out infinite;

    @media (max-width: 1199px) {
      right: -38px;
      top: 110px;
      width: 98px;
      height: 98px;
    }

    @media (max-width: 768px) {
      right: -24px;
      top: 78px;
      width: 75px;
      height: 75px;
    }
  }
}

@keyframes pulseHeartGlowLeft {
  0%, 100% {
    opacity: 0.7;
    transform: translateY(0px) rotate(-14deg) scale(1);
  }
  50% {
    opacity: 0.95;
    transform: translateY(-8px) rotate(-10deg) scale(1.08);
  }
}

@keyframes pulseHeartGlowRight {
  0%, 100% {
    opacity: 0.65;
    transform: translateY(0px) rotate(16deg) scale(1);
  }
  50% {
    opacity: 0.92;
    transform: translateY(-9px) rotate(20deg) scale(1.09);
  }
}

@keyframes floatHeartSmallLeft {
  0%, 100% {
    transform: translateY(0px) rotate(12deg) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translateY(-8px) rotate(18deg) scale(1.15);
    opacity: 1;
  }
}

@keyframes floatHeartSmallRight {
  0%, 100% {
    transform: translateY(0px) rotate(-10deg) scale(1);
    opacity: 0.75;
  }
  50% {
    transform: translateY(-9px) rotate(-4deg) scale(1.18);
    opacity: 0.95;
  }
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  outline: none;
  touch-action: pan-y;
  user-select: none;
}

.swiper-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  will-change: transform;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  min-height: 100%;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;

  // Bottom dark gradient overlay so text & input are always readable
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 280px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.92) 0%, rgba(0, 0, 0, 0.55) 55%, transparent 100%);
    pointer-events: none;
    z-index: 4;
  }
}

.media-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  cursor: pointer;

  .media-skeleton {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #1a0a2e 0%, #0d0515 100%);
    overflow: hidden;
    z-index: 1;

    .shimmer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(139, 92, 246, 0.15) 50%,
        transparent 100%
      );
      animation: shimmer 1.5s infinite;
    }
  }

  .media-content {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .heart-pop-anim {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
    pointer-events: none;
    filter: drop-shadow(0 4px 20px rgba(255, 45, 85, 0.6));
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

// Right side actions - profile, heart, sound, options
.right-actions {
  position: absolute;
  right: 14px;
  bottom: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 10;

  @media (min-width: 768px) {
    right: 16px;
    bottom: 92px;
    gap: 14px;
  }

  .action-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    transition: transform 0.2s;

    &:active {
      transform: scale(0.9);
    }
  }

  .profile-action {
    position: relative;
    width: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .avatar-wrapper {
      width: 48px;
      height: 48px;
      border: 2px solid #ec4899;
      border-radius: 50%;
      padding: 2px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: border-color 0.2s;

      &.followed {
        border-color: #10b981;
      }

      .b-avatar {
        width: 40px !important;
        height: 40px !important;
      }
    }

    .follow-badge {
      position: absolute;
      bottom: -7px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 20px;
      background: #ec4899;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      color: #fff;
      border: 2px solid #000;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
      transition: background 0.2s;

      span {
        font-size: 10px;
        font-weight: 800;
        color: #fff;
        line-height: 1;
      }

      svg {
        font-size: 9px;
        color: #fff !important;
      }

      &.followed {
        background: #10b981;
      }
    }
  }

  .heart-action {
    width: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 28px;
      filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5));
      color: #ffffff;
      transition: transform 0.2s, color 0.2s;

      &.liked {
        color: #ff2d55;
      }
    }

    &:hover svg {
      transform: scale(1.12);
    }

    .action-count {
      font-size: 11px;
      font-weight: 700;
      color: #ffffff;
      margin-top: 2px;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
    }
  }

  .sound-action {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      font-size: 18px;
      color: #fff;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
    }

    &:hover {
      transform: scale(1.1);
      background: rgba(0, 0, 0, 0.75);
    }
  }

  .create-action {
    .outer-ring {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(168, 85, 247, 0.25);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      transition: all 0.2s;

      .inner-ring {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1.5px solid rgba(255, 255, 255, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          font-size: 16px;
          color: #fff;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4));
        }
      }
    }

    &:hover .outer-ring {
      transform: scale(1.08);
      border-color: rgba(236, 72, 153, 0.8);
      background: rgba(236, 72, 153, 0.35);
    }
  }

  .more-action {
    width: 44px;
    height: 44px;

    .more-icon-wrapper {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: rgba(15, 10, 25, 0.6);
      border: 1px solid rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      transition: all 0.2s ease;

      &:hover {
        background: linear-gradient(135deg, rgba(168, 85, 247, 0.85), rgba(236, 72, 153, 0.85));
        border-color: rgba(255, 255, 255, 0.6);
        transform: scale(1.1);
      }
    }
  }
}

// Desktop slide navigation arrows
.desktop-slide-arrows {
  display: none;

  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: absolute;
    right: 20px;
    bottom: 40px;
    z-index: 50;

    .slide-arrow-btn {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background: rgba(25, 12, 45, 0.85);
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      backdrop-filter: blur(10px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
      transition: all 0.25s ease;

      &:hover:not(:disabled) {
        background: linear-gradient(135deg, #a855f7, #ec4899);
        border-color: transparent;
        transform: scale(1.1);
        box-shadow: 0 8px 25px rgba(236, 72, 153, 0.5);
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
}

// Bottom info section
.bottom-info {
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 14px;
  z-index: 10;

  @media (min-width: 768px) {
    bottom: 22px;
    left: 18px;
    right: 18px;
  }

  .user-info {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 10px;
    max-width: calc(100% - 62px);

    .user-avatar {
      cursor: pointer;
      flex-shrink: 0;
      border: 2px solid rgba(255, 255, 255, 0.6);
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.06);
      }
    }

    .user-details {
      flex: 1;
      min-width: 0;

      .user-name-row {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;

        .username {
          color: #ffffff;
          font-size: 16px;
          font-weight: 700;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
        }

        .user-age {
          color: rgba(255, 255, 255, 0.85);
          font-size: 15px;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
        }

        .verified-badge {
          color: #38bdf8;
          font-size: 14px;
          filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.6));
        }
      }

      /* =============================================
         PROMINENT AI / REAL BADGES (Daha Belirgin)
         ============================================= */
      .badge-wrapper {
        margin: 5px 0 6px 0;
        display: flex;
        align-items: center;
      }

      .content-type-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 11.5px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        user-select: none;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.5);
        transition: all 0.25s ease;

        &.real {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: #ffffff;
          border: 1.5px solid rgba(167, 243, 208, 0.85);
          box-shadow: 0 2px 12px rgba(16, 185, 129, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.45);

          .badge-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #ffffff;
            box-shadow: 0 0 6px #ffffff, 0 0 10px #a7f3d0;
            display: inline-block;
            animation: pulseRealDot 1.6s infinite ease-in-out;
          }
        }

        &.ai {
          background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%);
          color: #ffffff;
          border: 1.5px solid rgba(240, 171, 252, 0.85);
          box-shadow: 0 2px 12px rgba(217, 70, 239, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.45);

          .badge-icon {
            font-size: 12px;
            color: #fef08a;
            line-height: 1;
            display: inline-block;
            animation: sparkleAi 2s infinite ease-in-out;
          }
        }

        .badge-text {
          line-height: 1;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
        }
      }

      .content-text {
        color: rgba(255, 255, 255, 0.95);
        font-size: 13.5px;
        line-height: 1.4;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  /* =============================================
     ARAMA + MESAJ BUTONLARI (eski mesaj kutusunun yerine)
     ============================================= */
  .moment-actions-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;

    .moment-action-btn {
      flex: 1 1 0;
      min-width: 0;
      height: 44px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 0 14px;
      border-radius: 30px;
      border: 1px solid rgba(255, 255, 255, 0.22);
      color: #fff;
      font-size: 13.5px;
      font-weight: 700;
      cursor: pointer;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
      transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
        transform: translateY(-1px);
        filter: brightness(1.1);
      }

      &:active {
        transform: scale(0.96);
      }
    }

    // Arama (sesli/görüntülü): Keşfet slider'ındaki "Sohbete Başla" butonuyla (.cta-chat-pill-btn) aynı renk
    .moment-action-call {
      border: 0;
      background: linear-gradient(135deg, #d946ef 0%, #ea03b2 50%, #f43f5e 100%);
      box-shadow: 0 4px 16px rgba(234, 3, 178, 0.42);

      &:hover {
        filter: none;
        box-shadow: 0 6px 22px rgba(234, 3, 178, 0.58);
      }
    }

    // Mesaj: eski mesaj kutusu gibi koyu cam
    .moment-action-message {
      background: rgba(26, 26, 38, 0.82);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
    }

    @media (max-width: 575px) {
      gap: 8px;

      .moment-action-btn {
        height: 40px;
        font-size: 12.5px;
        padding: 0 10px;
      }
    }
  }
}

@keyframes pulseRealDot {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.6;
  }
}

@keyframes sparkleAi {
  0%, 100% {
    transform: rotate(0deg) scale(1);
    filter: drop-shadow(0 0 2px #ffd700);
  }
  50% {
    transform: rotate(20deg) scale(1.25);
    filter: drop-shadow(0 0 6px #ffffff);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  text-align: center;
  padding: 20px;

  h3 {
    margin-bottom: 20px;
  }

  img {
    max-width: 200px;
    opacity: 0.7;
  }
}

// Modal styles
.actions-modal-content {
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
  background: linear-gradient(180deg, #1f1035 0%, #120822 100%) !important;
  border: 1px solid rgba(168, 85, 247, 0.3) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8) !important;
}

.actions-list {
  .action-item {
    padding: 16px 20px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease;

    .action-icon {
      font-size: 16px;
    }

    &:hover {
      background: rgba(168, 85, 247, 0.2);
    }

    &:last-child {
      border-bottom: none;
    }

    &.cancel {
      color: rgba(255, 255, 255, 0.7);
      font-weight: 500;
      &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
      }
    }

    &.text-danger {
      color: #ff453a !important;
      &:hover {
        background: rgba(255, 69, 58, 0.15);
      }
    }

    &.text-warning {
      color: #ff9f0a !important;
      &:hover {
        background: rgba(255, 159, 10, 0.15);
      }
    }
  }
}

.choose-gift-modal {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;

  .gift {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    .gift-image {
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.1);
      }
    }

    .gift-price {
      font-size: 12px;
      margin-top: 4px;
      color: #666;
    }
  }
}
</style>

<style lang="scss">
// Üstteki süs kalpleri bilerek kabın dışına taşıyor; masaüstünde sayfa bu yüzden 12-21px yana
// kayabiliyordu. Yatayda kırpılır (clip kaydırma çubuğu oluşturmaz, dikey kaydırmayı etkilemez).
.app-content.content.moments-application,
.moments-content {
  overflow-x: clip;
}

.moments-tiktok .b-overlay-wrap {
  min-height: 100%;
  width: 100%;
  background: transparent !important;
}

body.moments-active,
.vertical-layout.is-moments-route,
.app-content.content.moments-application,
.vertical-layout:has(.moments-tiktok),
.app-content.content:has(.moments-tiktok) {
  background: transparent !important;
  border-bottom: none !important;
}

body.moments-active .app-content.content,
.vertical-layout.is-moments-route .app-content.content,
.app-content.content.moments-application,
.app-content.content:has(.moments-tiktok) {
  padding: 72px 0 0 0 !important;
  margin: 0 !important;
  background: transparent !important;
  min-height: 100vh !important;
  border-bottom: none !important;
}

body.moments-active .content-wrapper,
.moments-application .content-wrapper,
.app-content.content:has(.moments-tiktok) .content-wrapper {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  max-width: 100% !important;
  width: 100% !important;
  border-bottom: none !important;
}

body.moments-active .content-body,
.moments-application .content-body,
.app-content.content:has(.moments-tiktok) .content-body {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  width: 100% !important;
  border-bottom: none !important;
}

body.moments-active .header-navbar-shadow,
.moments-application .header-navbar-shadow,
.app-content.content:has(.moments-tiktok) .header-navbar-shadow {
  display: none !important;
}

body.moments-active .header-navbar,
.vertical-layout.is-moments-route .header-navbar,
.vertical-layout:has(.moments-tiktok) .header-navbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.45) !important;
}

@media (max-width: 768px) {
  body.moments-active .app-content.content,
  .vertical-layout.is-moments-route .app-content.content,
  .app-content.content.moments-application,
  .app-content.content:has(.moments-tiktok) {
    padding: 64px 0 calc(68px + env(safe-area-inset-bottom, 0px)) 0 !important;
    border-bottom: none !important;
  }
}

.actions-modal .modal-content {
  background: #1c1c1e !important;
  border: none;
}

.actions-modal .modal-body {
  padding: 0;
}

/* Moment ekleme penceresi (modal body'ye taşındığı için global) */
.new-post-modal {
  .modal-content {
    background: linear-gradient(160deg, #24175a 0%, #170f3d 100%);
    border: 1px solid rgba(150, 110, 255, 0.3);
    border-radius: 22px;
    box-shadow: 0 24px 60px rgba(4, 1, 20, 0.6);
    color: #f4f1ff;
  }

  .modal-body {
    padding: 22px 26px 26px;

    @media (max-width: 575px) { padding: 16px 14px 18px; }
  }

  .np-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 18px;
  }

  .np-title {
    display: flex;
    align-items: center;
    gap: 14px;

    h3 {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      margin: 0 0 2px;
    }

    p {
      color: rgba(226, 220, 255, 0.7);
      font-size: 13px;
      margin: 0;
    }
  }

  .np-icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(135deg, #ff4fa8, #c026d3);
    flex-shrink: 0;
  }

  .np-close {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1px solid rgba(170, 140, 255, 0.35);
    background: rgba(14, 10, 40, 0.6);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover { background: rgba(139, 92, 246, 0.3); }
  }

  .new-post-modal-upload {
    width: 100%;
    height: 296px;
    border: 2px dashed rgba(190, 160, 255, 0.5);
    border-radius: 18px;
    background: radial-gradient(ellipse at 50% 30%, rgba(234, 3, 178, 0.14), transparent 65%), rgba(139, 92, 246, 0.08);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    transition: background .15s ease, border-color .15s ease;

    &:hover {
      border-color: #c084fc;
      background: radial-gradient(ellipse at 50% 30%, rgba(234, 3, 178, 0.22), transparent 65%), rgba(139, 92, 246, 0.14);
    }

    @media (max-width: 575px) { height: 230px; }
  }

  .np-upload-icons {
    display: flex;
    gap: 14px;
  }

  .np-upload-icon {
    width: 62px;
    height: 62px;
    border-radius: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;

    &.photo {
      background: linear-gradient(135deg, #ff1f8f, #ea03b2);
      box-shadow: 0 8px 20px rgba(255, 31, 143, 0.4);
    }

    &.video {
      background: linear-gradient(135deg, #8b5cf6, #6366f1);
      box-shadow: 0 8px 20px rgba(139, 92, 246, 0.4);
    }
  }

  .np-upload-text {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }

  .np-upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border-radius: 9999px;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    background: linear-gradient(135deg, rgba(234, 3, 178, 0.28) 0%, rgba(168, 85, 247, 0.22) 50%, rgba(99, 102, 241, 0.12) 100%);
    border: 1px solid rgba(234, 3, 178, 0.35);
  }

  .new-post-modal-preview {
    width: 100%;
    height: 296px;
    overflow: hidden;
    position: relative;
    border-radius: 18px;
    background: #0d0828;
    border: 1px solid rgba(170, 140, 255, 0.25);
    cursor: zoom-in;

    #new-post-modal-viewer {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    video {
      height: 296px;
      object-fit: contain !important;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain !important;
    }

    @media (max-width: 575px) {
      height: 230px;
      video { height: 230px; }
    }
  }

  .np-remove {
    position: absolute;
    right: 12px;
    top: 12px;
    z-index: 2;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 0;
    color: #fff;
    background: rgba(10, 6, 30, 0.75);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    backdrop-filter: blur(4px);

    &:hover:not(:disabled) { background: #e11d48; }
  }

  .np-text {
    position: relative;
    margin-top: 14px;
  }

  .np-textarea {
    background: rgba(14, 10, 40, 0.55) !important;
    border: 1px solid rgba(170, 140, 255, 0.28) !important;
    border-radius: 14px !important;
    color: #fff !important;
    padding: 12px 14px 26px;
    box-shadow: none !important;

    &::placeholder { color: rgba(226, 220, 255, 0.45); }

    &:focus {
      border-color: #a855f7 !important;
      box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.2) !important;
    }
  }

  .np-counter {
    position: absolute;
    right: 14px;
    bottom: 8px;
    font-size: 11px;
    font-weight: 600;
    color: rgba(226, 220, 255, 0.55);
    pointer-events: none;

    &.over { color: #fc668a; }
  }

  .form-accepted {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 14px 0 0;
    padding: 12px 14px;
    border-radius: 14px;
    background: rgba(14, 10, 40, 0.45);
    border: 1px solid rgba(150, 110, 255, 0.2);
    color: rgba(236, 232, 255, 0.82);
    font-size: 12px;
    line-height: 17px;
    transition: border-color .15s ease, background .15s ease;

    &.checked {
      border-color: rgba(234, 3, 178, 0.4);
      background: linear-gradient(135deg, rgba(234, 3, 178, 0.14) 0%, rgba(168, 85, 247, 0.12) 50%, rgba(99, 102, 241, 0.06) 100%);
    }

    .np-check {
      flex-shrink: 0;
      margin-top: 1px;

      .custom-control-input:checked ~ .custom-control-label::before {
        background-color: #c026d3;
        background-image: linear-gradient(135deg, #ea03b2, #a855f7);
        border-color: transparent;
      }

      .custom-control-label::before {
        background-color: rgba(255, 255, 255, 0.1);
        border-color: rgba(170, 140, 255, 0.5);
      }
    }
  }

  .np-publish {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    max-width: 320px;
    margin: 20px auto 0;
    padding: 13px 20px;
    border: 0;
    border-radius: 9999px;
    color: #fff;
    font-size: 16px;
    font-weight: 800;
    background: linear-gradient(135deg, #ff1f8f, #7c3aed);
    box-shadow: 0 10px 24px rgba(255, 31, 143, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.25);
    cursor: pointer;
    transition: filter .15s ease, transform .15s ease, opacity .15s ease;

    &:hover:not(:disabled) {
      filter: brightness(1.1);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: .45;
      cursor: not-allowed;
      box-shadow: none;
    }
  }
}
</style>
